import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import "./i18next.js"

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

